import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/poolContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-abyss-950 py-14 sm:py-20" aria-labelledby="faq-title" data-id="element-109" data-mp="1bmllj4fjvriw">
      <div className="mx-auto max-w-3xl px-5" data-id="element-110" data-mp="1gjvjx9kx3div">
        <h2 id="faq-title" className="text-center font-display text-[2.2rem] font-bold uppercase leading-none text-frost-50 sm:text-[3rem]" data-id="element-111" data-mp="248o6wgjkab1c">
          Questions? Start here.
        </h2>

        <ul className="mt-10 divide-y divide-abyss-600 border-y border-abyss-600" data-id="element-112" data-mp="1uk68g5yr8g0v">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} data-id="element-113" data-mp="2n7imfrqunfik" data-mpi={i}>
                <h3 data-id="element-114" data-mp="2n6hall20eozs">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-5 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-aqua" data-id="element-115" data-mp="2n5z4zxtgiyf7">
                    <span className="text-[15px] font-semibold leading-snug text-frost-50 sm:text-[16px]" data-id="element-116" data-mp="19tvbnw3zheqa">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-aqua transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} strokeWidth={2} aria-hidden="true" data-id="element-117" data-mp="1ol49gsi1i6ei" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-118" data-mp="36q2o2tbxcut">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-119" data-mp="3udaz6225lcz8">
                      <p className="pb-5 text-[14.5px] leading-relaxed text-body" data-id="element-120" data-mp="2c9xfw6ivpiva">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}